module.exports = __webpack_public_path__ + "static/media/20b.eeedbce7.jpg";